<div class="p-5">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title class="!p-0">Logger</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-5">
            @for (item of oLogger.slice(0,show); track item.id) {
                <div class="logs">
                    {{$index}}
                    {{item.timestamp}}
                    <p>{{item.error}}</p>
                </div>
            }
        </mat-card-content>
        <mat-card-actions align="end">
            <button type="button" mat-flat-button color="primary" (click)="show = show + limit">VER MAS</button>
        </mat-card-actions>
    </mat-card>
</div>